import { useEffect, useRef, useState } from 'react';
import { message } from 'antd';
import client from '../api/client';

/**
 * ④ 项目编辑锁：进入编辑器时申请（同一项目仅 1 个编辑会话），
 * 被占用 → 只读模式；卸载/会话失效时释放。
 */
export function useEditLock(projectType: 'scene' | 'dashboard', projectId?: string) {
  const [locked, setLocked] = useState(true); // true=本会话持有编辑锁
  const [acquiring, setAcquiring] = useState(true);
  const acquiredRef = useRef(false);

  useEffect(() => {
    if (!projectId) {
      setAcquiring(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await client.post('/auth/edit-lock/acquire', { projectType, projectId });
        if (cancelled) return;
        acquiredRef.current = true;
        setLocked(true);
      } catch (err) {
        if (cancelled) return;
        const data = (err as { response?: { data?: { message?: string } } })?.response?.data;
        const msg = data?.message || (err as Error)?.message || '获取编辑锁失败';
        if (!cancelled && msg.includes('正在被其他用户编辑')) {
          message.warning('该项目正在被其他用户编辑，当前为只读模式');
          setLocked(false);
        } else if (!cancelled) {
          // 非锁冲突错误（如网络）默认仍进入编辑态，避免阻断业务
          setLocked(true);
        }
      } finally {
        if (!cancelled) setAcquiring(false);
      }
    })();

    return () => {
      cancelled = true;
      if (acquiredRef.current && projectId) {
        client.post('/auth/edit-lock/release', { projectType, projectId }).catch(() => {});
      }
    };
  }, [projectType, projectId]);

  return { locked, acquiring };
}